import * as Types from '../../../../@graphql/types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions =  {}
export type AuthorsListQueryVariables = Types.Exact<{
  editorId?: Types.Maybe<Types.Scalars['UUID']>;
  search?: Types.Maybe<Types.Scalars['String']>;
  status?: Types.Maybe<Types.Scalars['Boolean']>;
  after?: Types.Maybe<Types.Scalars['String']>;
  first?: Types.Maybe<Types.Scalars['Int']>;
}>;


export type AuthorsListQuery = (
  { __typename?: 'Query' }
  & { authors_list?: Types.Maybe<(
    { __typename?: 'AuthorsConnection' }
    & { edges: Array<Types.Maybe<(
      { __typename?: 'AuthorsEdge' }
      & { node?: Types.Maybe<(
        { __typename?: 'Author' }
        & Pick<Types.Author, 'uid' | 'jobTitle' | 'status' | 'isActive' | 'firstName' | 'lastName' | 'mail'>
        & { editor?: Types.Maybe<(
          { __typename?: 'Editor' }
          & Pick<Types.Editor, 'id' | 'name'>
        )> }
      )> }
    )>>, pageInfo: (
      { __typename?: 'PageInfo' }
      & Pick<Types.PageInfo, 'endCursor' | 'hasNextPage'>
    ) }
  )> }
);

export type EditorsQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type EditorsQuery = (
  { __typename?: 'Query' }
  & { editors?: Types.Maybe<Array<(
    { __typename?: 'Editor' }
    & Pick<Types.Editor, 'uid' | 'name'>
  )>> }
);

export type DeactivateAuthorMutationVariables = Types.Exact<{
  data: Types.DeactivateAuthorInput;
}>;


export type DeactivateAuthorMutation = (
  { __typename?: 'Mutation' }
  & { deactivateAuthor?: Types.Maybe<(
    { __typename?: 'DeactivateAuthorPayload' }
    & Pick<Types.DeactivateAuthorPayload, 'status'>
  )> }
);

export type ActivateAuthorMutationVariables = Types.Exact<{
  data: Types.ActivateAuthorInput;
}>;


export type ActivateAuthorMutation = (
  { __typename?: 'Mutation' }
  & { activateAuthor?: Types.Maybe<(
    { __typename?: 'ActivateAuthorPayload' }
    & Pick<Types.ActivateAuthorPayload, 'status'>
  )> }
);

export type CreateAuthorMutationVariables = Types.Exact<{
  data: Types.CreateAuthorInput;
}>;


export type CreateAuthorMutation = (
  { __typename?: 'Mutation' }
  & { createAuthor?: Types.Maybe<(
    { __typename?: 'CreateAuthorPayload' }
    & Pick<Types.CreateAuthorPayload, 'status'>
    & { author?: Types.Maybe<(
      { __typename?: 'Author' }
      & Pick<Types.Author, 'uid'>
    )> }
  )> }
);


export const AuthorsListDocument = gql`
    query authorsList($editorId: UUID, $search: String, $status: Boolean, $after: String, $first: Int) {
  authors_list(
    limit: 20
    filter: {editorId: $editorId, search: $search, status: $status}
    after: $after
    first: $first
  ) {
    edges {
      node {
        uid
        jobTitle
        status
        isActive
        firstName
        lastName
        mail
        editor {
          id
          name
        }
      }
    }
    pageInfo {
      endCursor
      hasNextPage
    }
  }
}
    `;

/**
 * __useAuthorsListQuery__
 *
 * To run a query within a React component, call `useAuthorsListQuery` and pass it any options that fit your needs.
 * When your component renders, `useAuthorsListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAuthorsListQuery({
 *   variables: {
 *      editorId: // value for 'editorId'
 *      search: // value for 'search'
 *      status: // value for 'status'
 *      after: // value for 'after'
 *      first: // value for 'first'
 *   },
 * });
 */
export function useAuthorsListQuery(baseOptions?: Apollo.QueryHookOptions<AuthorsListQuery, AuthorsListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AuthorsListQuery, AuthorsListQueryVariables>(AuthorsListDocument, options);
      }
export function useAuthorsListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AuthorsListQuery, AuthorsListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AuthorsListQuery, AuthorsListQueryVariables>(AuthorsListDocument, options);
        }
export type AuthorsListQueryHookResult = ReturnType<typeof useAuthorsListQuery>;
export type AuthorsListLazyQueryHookResult = ReturnType<typeof useAuthorsListLazyQuery>;
export type AuthorsListQueryResult = Apollo.QueryResult<AuthorsListQuery, AuthorsListQueryVariables>;
export const EditorsDocument = gql`
    query editors {
  editors {
    uid
    name
  }
}
    `;

/**
 * __useEditorsQuery__
 *
 * To run a query within a React component, call `useEditorsQuery` and pass it any options that fit your needs.
 * When your component renders, `useEditorsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEditorsQuery({
 *   variables: {
 *   },
 * });
 */
export function useEditorsQuery(baseOptions?: Apollo.QueryHookOptions<EditorsQuery, EditorsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EditorsQuery, EditorsQueryVariables>(EditorsDocument, options);
      }
export function useEditorsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EditorsQuery, EditorsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EditorsQuery, EditorsQueryVariables>(EditorsDocument, options);
        }
export type EditorsQueryHookResult = ReturnType<typeof useEditorsQuery>;
export type EditorsLazyQueryHookResult = ReturnType<typeof useEditorsLazyQuery>;
export type EditorsQueryResult = Apollo.QueryResult<EditorsQuery, EditorsQueryVariables>;
export const DeactivateAuthorDocument = gql`
    mutation deactivateAuthor($data: DeactivateAuthorInput!) {
  deactivateAuthor(data: $data) {
    status
  }
}
    `;
export type DeactivateAuthorMutationFn = Apollo.MutationFunction<DeactivateAuthorMutation, DeactivateAuthorMutationVariables>;

/**
 * __useDeactivateAuthorMutation__
 *
 * To run a mutation, you first call `useDeactivateAuthorMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeactivateAuthorMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deactivateAuthorMutation, { data, loading, error }] = useDeactivateAuthorMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useDeactivateAuthorMutation(baseOptions?: Apollo.MutationHookOptions<DeactivateAuthorMutation, DeactivateAuthorMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeactivateAuthorMutation, DeactivateAuthorMutationVariables>(DeactivateAuthorDocument, options);
      }
export type DeactivateAuthorMutationHookResult = ReturnType<typeof useDeactivateAuthorMutation>;
export type DeactivateAuthorMutationResult = Apollo.MutationResult<DeactivateAuthorMutation>;
export type DeactivateAuthorMutationOptions = Apollo.BaseMutationOptions<DeactivateAuthorMutation, DeactivateAuthorMutationVariables>;
export const ActivateAuthorDocument = gql`
    mutation activateAuthor($data: ActivateAuthorInput!) {
  activateAuthor(data: $data) {
    status
  }
}
    `;
export type ActivateAuthorMutationFn = Apollo.MutationFunction<ActivateAuthorMutation, ActivateAuthorMutationVariables>;

/**
 * __useActivateAuthorMutation__
 *
 * To run a mutation, you first call `useActivateAuthorMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useActivateAuthorMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [activateAuthorMutation, { data, loading, error }] = useActivateAuthorMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useActivateAuthorMutation(baseOptions?: Apollo.MutationHookOptions<ActivateAuthorMutation, ActivateAuthorMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ActivateAuthorMutation, ActivateAuthorMutationVariables>(ActivateAuthorDocument, options);
      }
export type ActivateAuthorMutationHookResult = ReturnType<typeof useActivateAuthorMutation>;
export type ActivateAuthorMutationResult = Apollo.MutationResult<ActivateAuthorMutation>;
export type ActivateAuthorMutationOptions = Apollo.BaseMutationOptions<ActivateAuthorMutation, ActivateAuthorMutationVariables>;
export const CreateAuthorDocument = gql`
    mutation createAuthor($data: CreateAuthorInput!) {
  createAuthor(data: $data) {
    status
    author {
      uid
    }
  }
}
    `;
export type CreateAuthorMutationFn = Apollo.MutationFunction<CreateAuthorMutation, CreateAuthorMutationVariables>;

/**
 * __useCreateAuthorMutation__
 *
 * To run a mutation, you first call `useCreateAuthorMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateAuthorMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createAuthorMutation, { data, loading, error }] = useCreateAuthorMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCreateAuthorMutation(baseOptions?: Apollo.MutationHookOptions<CreateAuthorMutation, CreateAuthorMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateAuthorMutation, CreateAuthorMutationVariables>(CreateAuthorDocument, options);
      }
export type CreateAuthorMutationHookResult = ReturnType<typeof useCreateAuthorMutation>;
export type CreateAuthorMutationResult = Apollo.MutationResult<CreateAuthorMutation>;
export type CreateAuthorMutationOptions = Apollo.BaseMutationOptions<CreateAuthorMutation, CreateAuthorMutationVariables>;